import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7c8cbf6e"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onClick"]

import { useStore } from 'vuex'
import { useInsuranceStore } from '@/compositions/insurance/index'
import { computed, reactive, nextTick, onMounted, onUnmounted, watch, onActivated } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'form-page-tab-wrap',
  setup(__props) {

const store = useStore()
const isMiniProgram = computed(() => store.getters.isMiniProgram)
const headerHeight = computed(() => (isMiniProgram.value ? 0 : 44))
const { insranceState } = useInsuranceStore()
// 表单页layout信息
const tabLayoutInfo = reactive({
  top: 0,
  formItemTop: 0,
  activeIndex: 0,
  formInsurantTop: 0,
  parentWrapTop: 0,
  show: false,
  opacity: 0,
  firstVal: 0,
  secondVal: 0,
  list: [
    {
      label: '保险方案',
    },
    {
      label: '投保人信息',
    },
    {
      label: '被保人信息',
    },
  ],
})

const getTabInfoItemStyle = computed(() => {
  if (tabLayoutInfo.opacity == 0) {
    return { display: 'none' }
  }
  return {
    // top: tabLayoutInfo.formItemTop + 'px',
    opacity: tabLayoutInfo.opacity,
  }
})
// 监听由于查看保险明细时，导致的高度数据变化
watch(
  () => insranceState.priceDetailItemChangekey,
  () => {
    initPageTabItem()
  }
)
// 设置tab选中
function setTabActive(index: number) {
  let target = document.getElementById('main-wrap-item')
  if (!target) {
    return
  }
  if (index === 0) {
    target.scrollTop = 0
  } else if (index === 1) {
    target.scrollTop = tabLayoutInfo.firstVal + 44
  } else {
    target.scrollTop = tabLayoutInfo.secondVal
  }
  nextTick(() => {
    tabLayoutInfo.activeIndex = index
  })
}
// 获取元素距离父级元素距离
// 获取子元素相对于其父元素的顶部距离
function getElementTopRelativeToParent(element: HTMLElement, parent: HTMLElement) {
  if (!element) {
    return 0
  }
  let topDistance = element.getBoundingClientRect().top // 相对于定位上下文的顶部距离
  // 如果父元素有滚动条，需要减去已经滚动的部分
  topDistance += parent?.scrollTop || 0

  // 如果需要，可以减去父元素的上边框（通常clientTop为0，除非有特殊的边框样式）
  // topDistance -= parent.clientTop || 0;

  // 注意：clientTop通常用于获取元素的上边框宽度，但在大多数标准情况下，它的值为0
  // 除非父元素有通过CSS设置的上边框，并且这个边框影响了布局（比如不是transparent或0宽度）

  // 返回最终计算出的顶部距离
  return topDistance
}
// 初始化标签页
function initPageTabItem() {
  // 滚动容器数据
  let target = document.getElementById('main-wrap-item')
  if (!target) {
    return
  }
  // 投保人元素id
  const targetId = 'mainFormTarget'
  // 被保人元素id
  const target2Id = 'mainFormInsurantTarget'
  const el = document.getElementById(targetId)
  const el2 = document.getElementById(target2Id)
  if (!el || !el2) {
    return
  }
  const parentReactInfo = target.getBoundingClientRect()
  tabLayoutInfo.formItemTop = getElementTopRelativeToParent(el, target)
  tabLayoutInfo.formInsurantTop = getElementTopRelativeToParent(el2, target)
  tabLayoutInfo.parentWrapTop = parentReactInfo.top || 0
  tabLayoutInfo.firstVal = tabLayoutInfo.formItemTop - 48 - 44 - headerHeight.value - 12
  tabLayoutInfo.secondVal = tabLayoutInfo.formInsurantTop - 48 - headerHeight.value - 12
}
// 滚动执行函数
function scrollHandle() {
  let target = document.getElementById('main-wrap-item')
  if (!target) {
    return
  }
  const scrollTop = target.scrollTop
  // 48是tab高度
  let firstVal = tabLayoutInfo.firstVal
  let secondVal = tabLayoutInfo.secondVal
  if (scrollTop <= firstVal) {
    tabLayoutInfo.opacity = 0
    tabLayoutInfo.activeIndex = 0
  } else if (scrollTop > firstVal && scrollTop < secondVal) {
    tabLayoutInfo.opacity = Math.min(1, (scrollTop - firstVal) / 44)
    tabLayoutInfo.activeIndex = 1
  } else if (scrollTop > secondVal) {
    tabLayoutInfo.opacity = 1
    tabLayoutInfo.activeIndex = 2
  }
}
// 监听滚动判断显隐
function watchPageScroll() {
  let target = document.getElementById('main-wrap-item')
  if (!target) {
    return
  }
  target.addEventListener('scroll', () => {
    scrollHandle()
  })
}
onActivated(() => {
  scrollHandle()
})
onMounted(() => {
  initPageTabItem()
  watchPageScroll()
  window.addEventListener('resize', initPageTabItem)
})
onUnmounted(() => {
  window.removeEventListener('resize', initPageTabItem)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["tab-info-item", _unref(isMiniProgram) ? 'tab-info-item-mini' : '']),
    style: _normalizeStyle(_unref(getTabInfoItemStyle))
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tabLayoutInfo.list, (item, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: index,
        onClick: ($event: any) => (setTabActive(index))
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(tabLayoutInfo.activeIndex === index ? 'active' : '')
        }, _toDisplayString(item.label), 3)
      ], 8, _hoisted_1))
    }), 128))
  ], 6))
}
}

})